(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const PRODUCT_PATH = /\/products\/([^/?#]+)/;

  const cartUpsells = {
    'prime-choice-deep-calm-formula': 'prime-choice-sleep-formula-60-caps-non-habit-forming-sleeprestfulsleep-relaxed-refreshed',
    'prime-choice-prime-brain': 'prime-choice-prime-one',
    'prime-choice-alpha-drive': 'creatine',
    'prime-choice-test-ultra': 'creatine',
    'prime-choice-collagen-complex-i-ii-iii-v-x-womens-90-caps': 'prime-choice-face-serum-womens-2oz',
    'collagen-complex-i-ii-iii-v-x-90-caps-copy': 'prime-choice-face-serum-womens-2oz',
    'prime-choice-hair-skin-nails-ultra-womens': 'prime-choice-face-serum-womens-2oz',
    'hair-skin-nails-ultra-mens': 'face-serum-mens-2oz',
    'prime-choice-digestive-plus': 'prime-choice-probiotic-60b-digestion-gutbalance-wellness',
    'prime-choice-gut-flush': 'prime-choice-probiotic-60b-digestion-gutbalance-wellness',
    'prime-choice-shred-fast': 'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support',
    'shred-fast-1-month-supply': 'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support',
    'prime-choice-sleep-formula-60-caps-non-habit-forming-sleeprestfulsleep-relaxed-refreshed': 'prime-choice-deep-calm-formula',
  };

  const bundleUpgrades = {
    'prime-choice-deep-calm-formula': 'prime-brain-deep-sleep-bundle',
    'prime-choice-prime-brain': 'prime-brain-deep-sleep-bundle',
    'prime-choice-sleep-formula-60-caps-non-habit-forming-sleeprestfulsleep-relaxed-refreshed': 'prime-brain-deep-sleep-bundle',
    'prime-choice-alpha-drive': 'get-shredded-muscle-pack',
    'prime-choice-test-ultra': 'get-shredded-muscle-pack',
    'creatine': 'get-shredded-muscle-pack',
    'prime-choice-collagen-complex-i-ii-iii-v-x-womens-90-caps': 'womens-wellness-pack',
    'collagen-complex-i-ii-iii-v-x-90-caps-copy': 'womens-wellness-pack',
    'prime-choice-hair-skin-nails-ultra-womens': 'womens-wellness-pack',
    'prime-choice-face-serum-womens-2oz': 'womens-wellness-pack',
    'prime-choice-digestive-plus': 'complete-full-body-detox',
    'prime-choice-gut-flush': 'complete-full-body-detox',
    'prime-choice-probiotic-60b-digestion-gutbalance-wellness': 'complete-full-body-detox',
    'prime-choice-shred-fast': '24hr-weight-loss-bundle',
    'shred-fast-1-month-supply': '24hr-weight-loss-bundle',
    'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support': '24hr-weight-loss-bundle',
    'prime-choice-sea-moss': '24hr-weight-loss-bundle',
  };

  const replenishable = new Set([
    ...Object.keys(cartUpsells),
    'prime-choice-probiotic-60b-digestion-gutbalance-wellness',
    'prime-choice-berberine-bloodsugar-cholesterol-wellness-weight-support',
    'prime-choice-sea-moss',
    'prime-choice-prime-one',
    'prime-choice-face-serum-womens-2oz',
    'face-serum-mens-2oz',
  ]);

  const productCache = new Map();
  let productPending = false;
  let cartPending = false;

  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format((Number(cents) || 0) / 100);
    } catch (_error) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const moneyValue = (text) => {
    const normalized = String(text || '').replace(/[^0-9,.-]/g, '').replace(/,/g, '');
    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  };

  const normalizeDiscountBadges = (root = document) => {
    root.querySelectorAll('.pc-sale-badge, .pc-cart-sale-badge').forEach((badge) => {
      const scope = badge.closest('.card-wrapper, .pc-buybox, .cart-item, product-info') || badge.parentElement;
      const regular = moneyValue(
        scope?.querySelector('.pc-cart-compare-price, s.price-item--regular')?.textContent,
      );
      const sale = moneyValue(
        scope?.querySelector('.pc-cart-sale-price, .price-item--sale.price-item--last')?.textContent,
      );
      if (regular === null || sale === null || regular <= sale) return;
      badge.textContent = `Save ${Math.round(((regular - sale) / regular) * 100)}%`;
    });
  };

  const productHandle = () => decodeURIComponent(location.pathname.match(PRODUCT_PATH)?.[1] || '');

  const fetchProduct = async (handle) => {
    if (!handle) return null;
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(`${ROOT}products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' },
        }).then((response) => (response.ok ? response.json() : null)).catch(() => null),
      );
    }
    return productCache.get(handle);
  };

  const availableVariant = (product) => product?.variants?.find((variant) => variant.available) || null;

  const productImage = (product) => {
    const source = product?.featured_image || product?.images?.[0] || '';
    if (!source) return '';
    return source.startsWith('//') ? `https:${source}` : source;
  };

  const productCard = (product, eyebrow, buttonText) => {
    const variant = availableVariant(product);
    if (!variant) return null;

    const card = document.createElement('section');
    card.className = 'pc-aov-card';
    card.dataset.variantId = variant.id;

    const image = productImage(product);
    const url = product.url || `${ROOT}products/${product.handle}`;
    card.innerHTML = `
      ${image ? `<a class="pc-aov-card__image" href="${escapeHtml(url)}"><img src="${escapeHtml(image)}" alt="" loading="lazy"></a>` : ''}
      <div class="pc-aov-card__content">
        <span class="pc-aov-card__eyebrow">${escapeHtml(eyebrow)}</span>
        <a class="pc-aov-card__title" href="${escapeHtml(url)}">${escapeHtml(product.title)}</a>
        <span class="pc-aov-card__price">${money(variant.price)}</span>
        <button class="pc-aov-card__button" type="button">${escapeHtml(buttonText)}</button>
        <p class="pc-aov-card__status" role="status" aria-live="polite"></p>
      </div>`;
    return card;
  };

  const addItem = async (variantId, button, status) => {
    const cartDrawer = document.querySelector('cart-drawer');
    const sectionIds = cartDrawer?.getSectionsToRender?.().map((section) => section.id) || [];
    button.disabled = true;
    button.classList.add('is-loading');
    status.textContent = '';

    try {
      const payload = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }
      const response = await fetch(window.routes?.cart_add_url || `${ROOT}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Unable to add this item.');

      button.textContent = 'Added';
      status.textContent = 'Added to your cart.';
      if (cartDrawer && state.sections) {
        delete cartDrawer.dataset.pcAovCartChecked;
        cartDrawer.renderContents(state);
      }
      document.dispatchEvent(new CustomEvent('pc:aov-item-added', { detail: { variantId } }));
    } catch (error) {
      status.textContent = error.message || 'Unable to add this item.';
      button.disabled = false;
    } finally {
      button.classList.remove('is-loading');
    }
  };

  const bindAdd = (card) => {
    const button = card.querySelector('.pc-aov-card__button');
    const status = card.querySelector('.pc-aov-card__status');
    button.addEventListener('click', () => addItem(card.dataset.variantId, button, status));
  };

  const quantityInput = () => {
    return document.querySelector('.pc-buybox input[name="quantity"]') ||
      [...document.querySelectorAll('product-info input[name="quantity"]')]
        .find((input) => input.offsetWidth || input.offsetHeight) ||
      document.querySelector('input[name="quantity"]');
  };

  const SUPPLY_MULTIPLIERS = { 1: 1, 2: 0.95, 3: 0.90 };

  // Subscription (selling plan) awareness ---------------------------------
  const subscriptionRadios = () => [...document.querySelectorAll('input[type="radio"][name^="purchaseOption"]')];

  const subscriptionSelected = () => {
    const radios = subscriptionRadios();
    if (radios.length < 2) return false;
    const checked = radios.find((radio) => radio.checked);
    if (!checked) return false;
    const label = (checked.closest('label')?.textContent || checked.parentElement?.textContent || '').toLowerCase();
    return !/one[- ]?time/.test(label);
  };

  // Unit price for the currently selected purchase option, in dollars.
  const selectedUnitPrice = () => {
    const radios = subscriptionRadios();
    const checked = radios.find((radio) => radio.checked);
    if (checked) {
      const label = checked.closest('label')?.textContent || checked.parentElement?.textContent || '';
      const matches = label.match(/[$€£]\s?\d[\d,]*(?:\.\d{1,2})?/g);
      if (matches && matches.length) {
        const value = moneyValue(matches[matches.length - 1]);
        if (value !== null && value > 0) return value;
      }
    }
    return null;
  };

  const priceElements = () => {
    const container = document.querySelector('product-info .price, .pc-buybox .price, [id^="price-"] .price');
    if (!container) return null;
    const saleEl = container.querySelector('.price-item--sale.price-item--last');
    const regularEl = container.querySelector('.price__regular .price-item--regular');
    const compareEl = container.querySelector('s.price-item--regular');
    const badgeEl = container.querySelector('.price__badge-sale span span, .price__badge-sale span') ||
      document.querySelector('.pc-sale-badge');
    return { container, priceEl: saleEl || regularEl, compareEl, badgeEl };
  };

  const supplyOriginals = {};
  let currentSupplyQty = 1;

  const supplyNoteEl = () => document.querySelector('.pc-aov-supply__note');

  const applySupplyPricing = (qty) => {
    currentSupplyQty = qty;
    const els = priceElements();
    if (!els || !els.priceEl) return;

    if (!('price' in supplyOriginals)) {
      supplyOriginals.price = els.priceEl.textContent;
      supplyOriginals.compare = els.compareEl ? els.compareEl.textContent : null;
      supplyOriginals.badge = els.badgeEl ? els.badgeEl.textContent : null;
    }

    const isSub = subscriptionSelected();
    const note = supplyNoteEl();
    if (note) {
      note.textContent = isSub && qty > 1
        ? `Total per monthly delivery (${qty} units each delivery)`
        : '';
      note.hidden = !note.textContent;
    }

    const mult = SUPPLY_MULTIPLIERS[qty] || 1;
    if (qty <= 1) {
      els.priceEl.textContent = supplyOriginals.price;
      if (els.compareEl && supplyOriginals.compare !== null) els.compareEl.textContent = supplyOriginals.compare;
      if (els.badgeEl && supplyOriginals.badge !== null) els.badgeEl.textContent = supplyOriginals.badge;
      return;
    }

    // Base unit price: subscription (selling plan) price when Subscribe & Save
    // is selected, otherwise the one-time price captured from the price block.
    const oneTimeUnit = moneyValue(supplyOriginals.price);
    const unitPrice = (isSub ? selectedUnitPrice() : null) ?? oneTimeUnit;
    if (unitPrice === null) return;
    const total = qty * unitPrice * mult;
    els.priceEl.textContent = money(Math.round(total * 100));

    const unitCompare = supplyOriginals.compare !== null ? moneyValue(supplyOriginals.compare) : null;
    if (els.compareEl && unitCompare !== null) {
      els.compareEl.textContent = money(Math.round(qty * unitCompare * 100));
    }
    if (els.badgeEl) {
      let pct;
      if (unitCompare && unitCompare > unitPrice * mult) {
        pct = Math.round((1 - total / (qty * unitCompare)) * 100);
      } else {
        pct = Math.round((1 - mult) * 100);
      }
      const original = supplyOriginals.badge || '';
      els.badgeEl.textContent = original.trim().startsWith('-') ? `-${pct}%` : `Save ${pct}%`;
    }
  };

  // Default the purchase option to Subscribe & Save (AOV strategy).
  // Runs once, only if the user hasn't interacted with the radios yet.
  let subDefaultDone = false;
  let subUserTouched = false;
  document.addEventListener('pointerdown', (event) => {
    const label = event.target.closest?.('label');
    if (event.target.matches?.('input[type="radio"][name^="purchaseOption"]') ||
        label?.querySelector('input[type="radio"][name^="purchaseOption"]')) {
      subUserTouched = true;
    }
  }, true);

  const defaultToSubscription = () => {
    if (subDefaultDone || subUserTouched) return subDefaultDone;
    const radios = subscriptionRadios();
    if (radios.length < 2) return false;
    const subRadio = radios.find((radio) => {
      const label = (radio.closest('label')?.textContent || radio.parentElement?.textContent || '').toLowerCase();
      return !/one[- ]?time/.test(label);
    });
    if (!subRadio || subRadio.checked) {
      subDefaultDone = true;
      return true;
    }
    subDefaultDone = true;
    subRadio.click();
    subRadio.checked = true;
    subRadio.dispatchEvent(new Event('input', { bubbles: true }));
    subRadio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const subObserverStart = () => {
    if (!productHandle()) return;
    if (defaultToSubscription()) return;
    const observer = new MutationObserver(() => {
      if (defaultToSubscription()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 8000);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', subObserverStart, { once: true });
  } else {
    subObserverStart();
  }

  // Recompute totals when the customer switches purchase option
  // (one-time vs Subscribe & Save) or the variant/price re-renders.
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('input[type="radio"][name^="purchaseOption"], input[name="selling_plan"], variant-selects input, variant-selects select')) return;
    window.setTimeout(() => {
      // Theme re-rendered the price block: re-capture originals at qty 1 scale.
      delete supplyOriginals.price;
      delete supplyOriginals.compare;
      delete supplyOriginals.badge;
      applySupplyPricing(currentSupplyQty);
    }, 150);
  }, true);

  const buildSupplySelector = (heading, subheading) => {
    const wrapper = document.createElement('section');
    wrapper.className = 'pc-aov-supply';
    wrapper.innerHTML = `
      <div class="pc-aov-heading">${escapeHtml(heading || 'Choose your supply')}</div>
      <p class="pc-aov-copy">${escapeHtml(subheading || 'Stock up and save — discount applied automatically at checkout.')}</p>
      <div class="pc-aov-supply__options" role="group" aria-label="Supply quantity">
        <button type="button" data-quantity="1" class="is-active">1 month</button>
        <button type="button" data-quantity="2">2 months — save 5%</button>
        <button type="button" data-quantity="3">3 months — save 10%</button>
      </div>
      <p class="pc-aov-supply__note" hidden></p>`;

    wrapper.querySelectorAll('[data-quantity]').forEach((button) => {
      button.addEventListener('click', () => {
        const qty = Number(button.dataset.quantity) || 1;
        // Update every quantity input (the buy-box script detaches the visible
        // one from the add-to-cart form, so the form keeps its own input).
        document.querySelectorAll('input[name="quantity"]').forEach((input) => {
          input.value = qty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        applySupplyPricing(qty);
        wrapper.querySelectorAll('[data-quantity]').forEach((item) => item.classList.toggle('is-active', item === button));
      });
    });
    return wrapper;
  };

  const renderProductPage = async () => {
    const handle = productHandle();
    if (!handle || productPending || document.querySelector('[data-pc-aov-product]')) return;

    const supplyHost = document.querySelector('[data-pc-supply-selector]');
    const bundleHost = document.querySelector('[data-pc-bundle-upsell]');
    const hasPlaceholders = Boolean(supplyHost || bundleHost);

    productPending = true;

    if (hasPlaceholders) {
      // Theme-editor blocks exist: fill placeholders in place (no positional hacks).
      let rendered = false;
      if (supplyHost && !supplyHost.children.length && replenishable.has(handle)) {
        supplyHost.appendChild(buildSupplySelector(supplyHost.dataset.heading, supplyHost.dataset.subheading));
        rendered = true;
      }
      const bundleHandle = bundleUpgrades[handle];
      if (bundleHost && !bundleHost.children.length && bundleHandle) {
        const product = await fetchProduct(bundleHandle);
        const card = productCard(product, bundleHost.dataset.eyebrow || 'Upgrade to the complete routine', 'Add bundle');
        if (card) {
          card.classList.add('pc-aov-card--bundle');
          bindAdd(card);
          bundleHost.appendChild(card);
          rendered = true;
        }
      }
      if (rendered || supplyHost?.children.length || bundleHost?.children.length) {
        (supplyHost || bundleHost).dataset.pcAovProduct = 'true';
      }
      productPending = false;
      return;
    }

    // Fallback for templates without the new blocks: legacy positional injection.
    const priceBlock = document.querySelector('.price__container, product-info .price, .pc-buybox .price')?.closest('.block');
    const govxBlock = document.querySelector('.pc-govx-offer')?.closest('.block');
    if (priceBlock && govxBlock && priceBlock !== govxBlock) {
      priceBlock.insertAdjacentElement('afterend', govxBlock);
    }

    const deliveryEls = document.querySelectorAll('.earliest-delivery, .latest-delivery, .earliest-delivery-value, .latest-delivery-value');
    const lastDelivery = deliveryEls.length ? deliveryEls[deliveryEls.length - 1] : null;
    const deliveryBlock = lastDelivery && (lastDelivery.closest('.block') || lastDelivery.closest('p') || lastDelivery.parentElement);
    const host = deliveryBlock ||
      document.querySelector('.pc-buybox .pc-product-facts')?.closest('.block') || document.querySelector('.pc-buybox .pc-cta') || document.querySelector('product-info product-form');
    if (!host) {
      productPending = false;
      return;
    }

    const region = document.createElement('div');
    region.className = 'pc-aov-product';
    region.dataset.pcAovProduct = 'true';

    if (replenishable.has(handle)) region.appendChild(buildSupplySelector());

    const bundleHandle = bundleUpgrades[handle];
    if (bundleHandle) {
      const product = await fetchProduct(bundleHandle);
      const card = productCard(product, 'Upgrade to the complete routine', 'Add bundle');
      if (card) {
        card.classList.add('pc-aov-card--bundle');
        bindAdd(card);
        region.appendChild(card);
      }
    }

    if (region.children.length) host.insertAdjacentElement('afterend', region);
    productPending = false;
  };

  const firstCartRecommendation = (cart) => {
    const handles = new Set((cart.items || []).map((item) => item.handle));
    for (const item of cart.items || []) {
      const target = cartUpsells[item.handle];
      if (target && !handles.has(target)) return target;
    }
    return null;
  };

  const renderCartUpsell = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || cartPending || drawer.dataset.pcAovCartChecked === 'true' || drawer.querySelector('[data-pc-aov-cart]')) return;
    cartPending = true;
    drawer.dataset.pcAovCartChecked = 'true';

    const cart = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .catch(() => ({ items: [] }));
    const target = firstCartRecommendation(cart);
    if (!target) {
      cartPending = false;
      return;
    }

    const product = await fetchProduct(target);
    const card = productCard(product, 'Complete your routine', 'Add');
    const items = drawer.querySelector('cart-drawer-items');
    if (!card || !items) {
      cartPending = false;
      return;
    }

    const region = document.createElement('div');
    region.className = 'pc-aov-cart';
    region.dataset.pcAovCart = 'true';
    region.appendChild(card);
    bindAdd(card);
    items.appendChild(region);
    drawer.querySelector('.cart-collection')?.classList.add('pc-aov-generic-hidden');
    cartPending = false;
  };

  let queued = false;
  const init = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(async () => {
      queued = false;
      await renderProductPage();
      await renderCartUpsell();
      normalizeDiscountBadges();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  let productRetries = 0;
  const productTimer = window.setInterval(() => {
    productRetries += 1;
    init();
    if (document.querySelector('[data-pc-aov-product]') || !productHandle() || productRetries >= 20) {
      window.clearInterval(productTimer);
    }
  }, 250);

  document.addEventListener('click', (event) => {
    if (!event.target.closest('#cart-icon-bubble, product-form button[name="add"]')) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer) delete drawer.dataset.pcAovCartChecked;
    window.setTimeout(init, 700);
  }, true);

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('pc:aov-item-added', () => setTimeout(init, 150));

  window.setTimeout(normalizeDiscountBadges, 500);
  window.setTimeout(normalizeDiscountBadges, 1500);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) delete drawer.dataset.pcAovCartChecked;
      window.setTimeout(init, 200);
    });
  }
})();
